import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const TERMINAL_OPTIONS = [
  "All Terminal",
  "All Departures Shop",
  "All Arrivals Shop",
  "Concourse A, B, C, D, T2, & AMIA",
  "Concourse A, B, C, & D",
  "Concourse A, B, & C",
  "Concourse A, B, & D",
  "Concourse A, & B",
  "Concourse T2, & AMIA",
];
const NONE = "__none__";
const SPECIFIC = "__specific__";

// Dropdown of standard locations; "Specific" reveals a free-text input. Unknown saved
// values (legacy free text) are shown as Specific with the text prefilled.
export function TerminalSelect({ value, specific, onChange, testId }) {
  const v = value || "";
  const isPreset = TERMINAL_OPTIONS.includes(v);
  const mode = specific || (v && !isPreset) ? SPECIFIC : v || NONE;
  const choose = (m) => {
    if (m === NONE) onChange("", false);
    else if (m === SPECIFIC) onChange(isPreset ? "" : v, true);
    else onChange(m, false);
  };
  return (
    <div className="space-y-1.5">
      <Select value={mode} onValueChange={choose}>
        <SelectTrigger data-testid={testId}>
          <SelectValue placeholder="Select terminal / shop" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NONE}>— None —</SelectItem>
          {TERMINAL_OPTIONS.map((o) => (
            <SelectItem key={o} value={o}>{o}</SelectItem>
          ))}
          <SelectItem value={SPECIFIC}>Specific…</SelectItem>
        </SelectContent>
      </Select>
      {mode === SPECIFIC && (
        <Input
          value={isPreset ? "" : v}
          onChange={(e) => onChange(e.target.value, true)}
          placeholder="Type the specific location, e.g. Concourse B Gate B12"
          className="text-sm"
          data-testid={`${testId}-specific`}
        />
      )}
    </div>
  );
}
